import { EMPTY_FUNCTION, EMPTY_OBJECT } from '../../../constants/common'
import { BUTTON_HEIGHT_24 } from '../../Button'
import { SearchButton } from '../SearchButton'
import { SearchSectionHeader } from '../SearchSectionHeader'

import * as styles from './SearchListHeader.module.css'

import LinkIcon from '../../../icons/open-in-new-window.svg'

/**
 * @import {SearchButtonProps} from "../SearchButton/SearchButton"
 * @import {SearchSectionHeaderProps} from "../SearchSectionHeader/SearchSectionHeader"
 */

/**
 * @typedef {SearchSectionHeaderProps} SearchListHeaderProps
 *
 * @property {React.ComponentType<SearchButtonProps>} Button
 *
 * @property {SearchButtonProps} buttonProps
 *
 * @property {SearchListValue} value
 *
 * @property {(search: SearchValue) => void} [onSearch]
 */

/**
 * @param {SearchListHeaderProps} props
 */
function SearchListHeader({
  Button = SearchButton,
  buttonProps: {
    Icon: ButtonIcon = LinkIcon,
    height: buttonHeihgt = BUTTON_HEIGHT_24,
    tooltip: buttonTooltip = 'Header.OpenSearchPageKey',
    ...buttonProps
  } = EMPTY_OBJECT,
  className = styles.SearchListHeader,
  value,
  onSearch = EMPTY_FUNCTION,
  ...sectionHeaderProps
}) {
  const { items, search } = value
  /*
   * TEMP:
   * Suppliers search uses global search, but redesigned search results page is not
   * implemented yet. For suppliers we set `links.page = null`, so this button should
   * be hidden until the results page exists.
   *
   * HOW TO REVERT:
   * - exclude isSearchPageAvailable
   */
  const isSearchPageAvailable = Boolean(search?.type?.links?.page)

  return (
    <SearchSectionHeader {...sectionHeaderProps} className={className}>
      {items?.length > 0 && isSearchPageAvailable ? (
        <Button
          {...buttonProps}
          Icon={ButtonIcon}
          height={buttonHeihgt}
          search={search}
          tooltip={buttonTooltip}
          onSearch={onSearch}
        />
      ) : null}
    </SearchSectionHeader>
  )
}

export default SearchListHeader
